import React from "react";
import {Dialog, DialogContent, Tab, Tabs} from "@material-ui/core";
import {CustomTabPanel} from "../ui-base/tab-panel";
import styled from "styled-components";
import {CustomCloseModalIcon} from "../ui-base/icons/custom-close-modal-icon";
import {useTranslation} from "react-i18next";

export const BookDescriptionDialog: React.FC<{open: boolean, onClose: any, fragment: string, description: string, summary: string, review?: string, tableOfContest?: string}> = ({open, onClose, fragment, description, summary, review, tableOfContest}) => {
    const [tabActive, setTabActive] = React.useState(0);
    const { t } = useTranslation('author');

    return (
        <Dialog
            maxWidth="lg"
            aria-labelledby="confirmation-dialog-title"
            open={open}
        >
            <DialogContent dividers>
                <Tabs value={tabActive} onChange={(event, newValue) => { setTabActive(newValue) }}>
                    <Tab label={t('common:bookDescriptionDialog.tabTitle1')} style={{fontSize: '0.9rem'}}/>
                    <Tab label={t('common:bookDescriptionDialog.tabTitle2')} style={{fontSize: '0.9rem'}}/>
                    <Tab label={t('common:bookDescriptionDialog.tabTitle3')} style={{fontSize: '0.9rem'}}/>
                    {review !== undefined &&
                        <Tab label={t('common:bookDescriptionDialog.tabTitle4')} style={{fontSize: '0.9rem'}}/>
                    }
                    {tableOfContest !== undefined &&
                        <Tab label={t('common:bookDescriptionDialog.tabTitle5')} style={{fontSize: '0.9rem'}}/>
                    }
                </Tabs>

                <CustomTabPanel value={tabActive} index={0}>
                    <StyledDescription>{fragment || '-'}</StyledDescription>
                </CustomTabPanel>

                <CustomTabPanel value={tabActive} index={1}>
                    <StyledDescription>{description || '-'}</StyledDescription>
                </CustomTabPanel>

                <CustomTabPanel value={tabActive} index={2}>
                    <StyledDescription>{summary || '-'}</StyledDescription>
                </CustomTabPanel>

                <CustomTabPanel value={tabActive} index={3}>
                    <StyledDescription>{review || '-'}</StyledDescription>
                </CustomTabPanel>

                <CustomTabPanel value={tabActive} index={4}>
                    <StyledDescription>{tableOfContest || '-'}</StyledDescription>
                </CustomTabPanel>


                <StyledCloseButton onClick={() => {
                    onClose();
                }}>
                    <CustomCloseModalIcon/>
                </StyledCloseButton>
            </DialogContent>
        </Dialog>
    );
}

const StyledDescription = styled('p')`
  font-size: 0.9rem;
  white-space: pre-line;
`;

const StyledCloseButton = styled('div')`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;
